// extracted by mini-css-extract-plugin
export default {"container":"CardDetails_container__K7I-c","cardImage":"CardDetails_cardImage__1lT6+","card":"CardDetails_card__mM-gf"};